<template>
    <project-step-container
            cover-page
            prev-to="go_broad_to_go_narrow_12"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject">
        <div class="content-cover">
            <div class="content-cover-item first-form-initial-3">
                <div class="content-cover-item-header">
                    <div class="rapid-icon"/>
                </div>
                <div class="content-cover-item-body">
                    <p class="content-cover-item-body-title cover-body-title-3 text-uppercase " tabindex="0">
                        {{getMessage(13 , 'rapidexperiment-title')}}</p>
                    <p class="content-cover-item-body-description  cover-body-title-3" tabindex="0">
                        {{getMessage(13 , 'rapidexperiment-sub')}}
                    </p>
                </div>
                <div class="content-cover-item-footer circles-icon"></div>
            </div>
            <div class="content-cover-item content-guide">
                <LinkStyleGuide class="guide-text guide-padding" @open-url="openGuide" :is-box-shadow="false"
                                icon-name="icon-guide" :text="getMessage(13 , 'rapidexperiment-guide')"/>
            </div>
        </div>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide";
    import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
    import {Steps} from "@/modules/D4D/Utils";

    export default {
        name: "RapidExperimentsWithCustomers13",
        components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_RAPID_EXPERIMENTS_CUSTOMERS,
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.RAPID_EXPERIMENTS),
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: 'rapid_experiments_with_customers_14', params: {index}})
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .content-text
        margin-top -35px
    .font-size
        .content-cover
           padding-bottom: 25px;
    .rapid-icon
        background url("../Images/rapid-icon.svg")
        height 89px
        width 183px
        background-repeat no-repeat

    .circles-icon
        background url("../Images/circles.svg")
        height 68px
        width 100%
        border-radius 0 0 27px 27px;
        opacity 0.5

    .guide-icon
        margin-top -20px
</style>
